package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_08_18_Day_4() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes continue their journey, heading north, following the pass between the two peaks. After a couple of hours, they see the same flying thing from yesterday. Their fears are confirmed, it appears to be a green dragon. Goram thinks it looks like an adult (100-800 years old). The heroes bravely hide from the dragon while they discuss their plan. Perhaps they can avoid the dragon by traveling at night and sleeping during the day when the dragon might spot them. Dirk casts the tiny hut, dis and they wait out the rest of the day. After a few hours they notice that the woods are void of any wildlife.")
    }
}
